export const getRoleLabel = (role: string) => {
  const labels: Record<string, string> = {
    'advisory.advisor': 'Assessor',
    'advisory.master': 'Master',
    'broker.broker': 'Corretor',
    'broker.master': 'Master',
    'insurer.administrator': 'Administrador',
    'insurer.customer_support': 'CX Atendimento',
    'insurer.underwriter': 'Subscritor',
    'insurer.commercial_manager': 'Gerente Comercial',
    'insurer.sales_executive': 'Executivo de Vendas',
    'insurer.commercial_assistant': 'Assistente Comercial',
    'insurer.finance': 'Financeiro',
  };
  return labels[role] || role;
};
